import { Controller } from '@hotwired/stimulus'

// Reading-progress bar. Sets the width of the `bar` target from how far the
// document is scrolled (0% at top → 100% at the bottom). Listens passively to
// window scroll/resize and updates on connect so the bar is correct on load and
// after a Turbo navigation. Auto-registered by the controllers glob.
export default class extends Controller {
  static targets = ['bar']

  connect() {
    this.update = this.update.bind(this)
    window.addEventListener('scroll', this.update, { passive: true })
    window.addEventListener('resize', this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener('scroll', this.update)
    window.removeEventListener('resize', this.update)
  }

  update() {
    if (!this.hasBarTarget) return
    const doc = document.documentElement
    const scrollable = doc.scrollHeight - doc.clientHeight
    const ratio = scrollable > 0 ? window.scrollY / scrollable : 0
    const percent = Math.min(100, Math.max(0, ratio * 100))
    this.barTarget.style.width = `${percent}%`
  }
}
